import { render, staticRenderFns } from "./_clients.vue?vue&type=template&id=74b3820f"
import script from "./_clients.vue?vue&type=script&lang=js"
export * from "./_clients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports